import { environment } from '@environments/environment';

export const GET_CABINET_BODIES_QUERY = (langcode: string, type_produit: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_finitions ?? '',
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          {
            term: {
              type_produit,
            },
          },
        ],
      },
    },
    _source: ['title', 'field_images'],
  },
});
